export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/ob-step-7.png?ad21d422929659ba8d01d04a0516a2bc";